import Marker, { MarkerProps } from "../../core/map/Marker";
import { SELECTED_PROPERTY_MARKER } from "src/constants/zIndexes";
import { useEffect, useState } from "react";
import selectedPinIcon from "../../icons/products/map-markers/selected-pin.svg";

export type PropertyMarkerProps = MarkerProps & {
  isSelected?: boolean;
  productType?: string;
  extension?: string;
};

const PropertyMarker = ({
  isSelected,
  productType,
  extension,
  ...otherProps
}: PropertyMarkerProps) => {
  const [iconUrl, setIconUrl] = useState<string>("");

  useEffect(() => {
    const loadIcon = async () => {
      if (productType && extension) {
        try {
          const icon = await import(
            `../../../components/icons/products/map-markers/${productType}-${extension}${
              isSelected ? "-selected" : ""
            }.svg`
          );
          setIconUrl(icon.default);
        } catch (error) {
          console.error(
            `Failed to load icon for ${productType}-${extension}:`,
            error
          );
        }
      }
    };

    loadIcon();
  }, [productType, extension, isSelected]);

  if (!iconUrl) {
    return null;
  }

  return (
    <>
      <Marker
        iconUrl={iconUrl}
        iconSize={20}
        zIndex={isSelected ? SELECTED_PROPERTY_MARKER : undefined}
        {...otherProps}
      />
      {isSelected && (
        <Marker
          position={otherProps.position}
          iconUrl={selectedPinIcon}
          iconSize={48}
          clickable={false}
          zIndex={SELECTED_PROPERTY_MARKER + 1}
        />
      )}
    </>
  );
};

export default PropertyMarker;
